import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { IDayOffSettings } from 'app/shared/model/day-off-settings.model';

import { createRequestOption } from '@appshared';

@Injectable({
  providedIn: 'root',
})
export class SettingService {
  protected resourceUrl = '/hrm-portal-api/api/settings/';

  constructor(
    public http: HttpClient,
    private _fuseProgressBarService: FuseProgressBarService
  ) {}

  getDayOffs(req?: any): Observable<any> {
    const options = createRequestOption(req);
    return this.http.get<IDayOffSettings>(`${this.resourceUrl}day-offs`, { params: options });
  }
}
